export function webOaPages() {
    const viewport = {
        content: "width=device-width, initial-scale=1.0, user-scalable=no",
    };
    return  {
        path: "/oa",
        name: "oa",
        component: () => import("@/views/admin/frame/home.vue"),
        meta: { title: "OA管理系统", viewport: viewport },
        children: [
            {
                path: "design",
                name: "design",
                component: () => import("@/views/admin/FormProcessDesign.vue"),
                meta: { title: "表单流程设计", viewport: viewport },
                children: [
                    {
                        path: "baseSetting",
                        name: "baseSetting",
                        component: () => import("@/views/admin/layout/FormBaseSetting.vue"),
                        meta: {title: '基础设置'}
                    }, {
                        path: "formSetting",
                        name: "formSetting",
                        component: () => import("@/views/admin/layout/FormDesign.vue"),
                        meta: {title: '表单设计'}
                    }, {
                        path: "processDesign",
                        name: "processDesign",
                        component: () => import("@/views/admin/layout/ProcessDesign.vue"),
                        meta: {title: '流程设计'}
                    }, {
                        path: "proSetting",
                        name: "proSetting",
                        component: () => import("@/views/admin/layout/FormProSetting.vue"),
                        meta: {title: '高级设置'}
                    }
                ]
            },
            {
                path: "approval",
                name: 'approval',
                component: () => import('@/views/workspace/approval/index.vue'),
                meta: { title: "申请列表", viewport: viewport },
            },
            {
                path: "startApply",
                name: 'startApply',
                component: () => import('@/views/workspace/approval/StartApply.vue'),
                meta: { title: "发起申请", viewport: viewport },
            },
            {
                path: "form",
                name: "form",
                component: () => import("@/views/admin/contacts/Home.vue"),
                meta: { title: "审批中心", viewport: viewport },
                children:[
                    {
                        path: "todo",
                        name: 'todo',
                        component: () => import('@/views/workspace/todo/index.vue'),
                        meta: { title: "待我处理", viewport: viewport },
                    },
                    {
                        path: "apply",
                        name: 'apply',
                        component: () => import('@/views/workspace/apply/index.vue'),
                        meta: { title: "我发起的", viewport: viewport },
                    },
                    {
                        path: "about",
                        name: 'about',
                        component: () => import('@/views/workspace/about/index.vue'),
                        meta: { title: "已审批的", viewport: viewport },
                    },
                    {
                        path: "cc",
                        name: 'cc',
                        component: () => import('@/views/workspace/cc/index.vue'),
                        meta: { title: "抄送我的", viewport: viewport },
                    },
                    {
                        path: "instance/tabs",
                        name: "detailTabs",
                        component: () =>
                            import("@/views/workspace/process/ProcessInstanceTabs.vue"),
                        meta: { title: "流程详情", viewport: viewport },
                    },
                    {
                        path: "instance/tabs/processDiagramViewer",
                        name: "processDiagramViewer",
                        component: () =>
                            import("@/views/admin/layout/ProcessDiagramViewer.vue"),
                        meta: { title: "节点详情", viewport: viewport },
                    },
                    {
                        path: "instance/tabs",
                        name: "processInstanceTabs",
                        component: () =>
                            import("@/views/workspace/process/ProcessInstanceTabs.vue"),
                        meta: { title: "流程详情", viewport: viewport },
                    },
                ]
            },
            {
                path: "approval",
                name: 'approval',
                component: () => import('@/views/workspace/approval/index.vue'),
                meta: { title: "发起审批", viewport: viewport },
            },
            {
                path: "dataCentre",
                name: "dataCentre",
                component: () => import("@/views/admin/contacts/Home.vue"),
                meta: { title: "数据中心", viewport: viewport },
                children:[
                    {
                        path: "applyData",
                        name: 'applyData',
                        component: () => import('@/views/workspace/submit/index.vue'),
                        meta: { title: "数据管理", viewport: viewport },
                    }
                ]
            },
            {
                path: "formsPanel",
                name: "formsPanel",
                component: () => import("@/views/admin/FormsPanel.vue"),
                meta: { title: "表单管理", viewport: viewport },
            },
            {
                path: "pastRecords",
                name: "pastRecords",
                component: () => import("@/views/admin/DingDingPastRecords.vue"),
                meta: { title: "钉钉历史表单", viewport: viewport },
            },
            {
                path: "baseSetting",
                name: "baseSetting",
                component: () => import("@/views/admin/layout/FormBaseSetting.vue"),
                meta: {title: '基础设置'}
            },
            {
                path: "formSetting",
                name: "formSetting",
                component: () => import("@/views/admin/layout/FormDesign.vue"),
                meta: {title: '表单设计'}
            },
            {
                path: "processDesign",
                name: "processDesign",
                component: () => import("@/views/admin/layout/ProcessDesign.vue"),
                meta: {title: '流程设计'}
            },
            {
                path: "proSetting",
                name: "proSetting",
                component: () => import("@/views/admin/layout/FormProSetting.vue"),
                meta: {title: '高级设置'}
            }
        ]
    }
}